const supportedLocales = ['de', 'en', 'es'];
const fallbackLocale = 'de';
export { supportedLocales, fallbackLocale };
